/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../Footer';
import Sidebar from './Sidebar';
import Header from '../Header';
import HeaderContext from '../Context/HeaderContext';

export default function Layout({ children }) {
    const [isPopup, setisPopup] = useState(false);
    const [ErrorMessage, SetErrorMessage] = useState('');
    const [SuccessMessage, SetSuccessMessage] = useState('');
    const [colorValue, setcolorValue] = useState(false);
    const [HardRefresh, setHardRefresh] = useState(false);
    const [collapsed, setcollapsed] = useState(false);
    useEffect(() => {
        setcollapsed(Boolean(localStorage.getItem('collapse') != 'false'));
    }, []);

    return (
        <div>
            <HeaderContext.Provider value={{
                isPopup,
                setisPopup,
                ErrorMessage,
                SetErrorMessage,
                SuccessMessage,
                SetSuccessMessage,
                colorValue,
                setcolorValue,
                HardRefresh,
                setHardRefresh,
                collapsed,
                setcollapsed,
            }}
            >
                <Header {...children} />
                <div className="flex">
                    <Sidebar {...children} />
                    <div className={`px-[25px] pb-[25px] ml-[26%] w-[74%] main-screen ${collapsed ? 'show' : ''}`}>
                        <Outlet />

                        {children}
                    </div>
                </div>
                <Footer />
            </HeaderContext.Provider>

        </div>
    );
}
